export interface ParsedUserAgent {
  browser: string;
  os: string;
  deviceType: 'mobile' | 'tablet' | 'desktop';
}

/**
 * Minimal user-agent parser covering the major browsers/platforms.
 * Order of checks matters: Edge and Chrome UAs also contain "Safari"/"Chrome".
 */
export function parseUserAgent(ua: string): ParsedUserAgent {
  const deviceType: ParsedUserAgent['deviceType'] = /iPad|Tablet/i.test(ua)
    ? 'tablet'
    : /Mobi|Android|iPhone/i.test(ua)
    ? 'mobile'
    : 'desktop';

  let os = 'Unknown';
  if (/Windows/i.test(ua)) os = 'Windows';
  else if (/Mac OS X/i.test(ua)) os = 'macOS';
  else if (/Android/i.test(ua)) os = 'Android';
  else if (/iPhone|iPad|iPod/i.test(ua)) os = 'iOS';
  else if (/Linux/i.test(ua)) os = 'Linux';

  let browser = 'Unknown';
  if (/Edg\//i.test(ua)) browser = 'Edge';
  else if (/Chrome\//i.test(ua) && !/Chromium/i.test(ua)) browser = 'Chrome';
  else if (/Firefox\//i.test(ua)) browser = 'Firefox';
  else if (/Safari\//i.test(ua) && !/Chrome/i.test(ua)) browser = 'Safari';
  else if (/Chromium/i.test(ua)) browser = 'Chromium';

  return { browser, os, deviceType };
}
